/**
 * Get the Honeycomb Portal URL based on the current environment.
 *
 * Logic:
 * 1. Check for valid NEXT_PUBLIC_PORTAL_URL env var override
 * 2. Check for development environment -> localhost:5000
 * 3. Default to production URL
 */
export const getPortalUrl = () => {
  // Allow env var override first if it exists and isn't empty
  if (process.env.NEXT_PUBLIC_PORTAL_URL) {
    return process.env.NEXT_PUBLIC_PORTAL_URL;
  }

  // Default logic based on environment
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:5000";
  }

  return "https://portal.sunhivemicroschool.org/";
};
